import React, { forwardRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a show/hide eye toggle.
 * Behaves like a plain <Input> — accepts all standard props (id, value, onChange, placeholder, autoComplete, required, minLength, disabled, className, ...).
 * Adds a right-aligned button that toggles the input's `type` between "password" and "text".
 */
const PasswordInput = forwardRef(function PasswordInput({ className = "", testid, ...props }, ref) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        className={`pr-10 ${className}`}
        data-testid={testid}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? "Hide password" : "Show password"}
        className="absolute right-2 top-1/2 -translate-y-1/2 h-7 w-7 grid place-items-center rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
